// extracted by mini-css-extract-plugin
export default {"productGallery":"QN-z","inQuickShop":"RN-z"};